import { useMemo, useState } from "react";
export function useLegacyState(initialState) {
    const [state, setState] = useState(initialState);
    const legacySetState = useMemo(() => (state) => {
        setState(prevState => {
            if (typeof state === "function") {
                return Object.assign(Object.assign({}, prevState), state(prevState));
            }
            else {
                return Object.assign(Object.assign({}, prevState), state);
            }
        });
    }, [state]);
    return [state, legacySetState];
}
//# sourceMappingURL=use-legacy-state.js.map